<template>
  <div class="multiple-blanks">
    <div v-for="(item,index) in issue.fillContext" :key="item.id" class="mb-2 last:mb-0">
      <div v-html="item.content.richText" class="mb-1 leading-base"></div>
      <div class="base-input-width">
        <relation-input
          :question-type="question.questionType"
          :question-id="question.id"
          :option-id="item.id"
          v-model="item.value"
          :type="item.inputType"
          :enable-relation="issue.setting.enableRelation"
          :disable-copy="issue.disableCopy"
          :readonly="view || item.readonly"
          :placeholder="item.placeholder"
          :prefix-icon="item.prefixIcon ? ('iconfont ' + item.prefixIcon) : ''"
        />
      </div>
      <template v-if="errorList[index]">
        <div class="text-danger mt-1">
          <span>{{errorList[index]}}</span>
        </div>
      </template>
      <!--      <el-input v-model="item.value" :type="item.inputType"></el-input>-->
    </div>
  </div>
</template>

<script>
import RelationInput from '@/questions/components/RelationInput'

export default {
  name: 'MultipleBlanks',
  components: { RelationInput },
  changeExpr: 'changeExpr',
  data(){
    return {
      errorList:[]
    }
  },
  computed: {
    changeExpr() {
      return this.issue.fillContext.map(item => item.value + item.content.fileList.length).join('-')
    }
  },
  created() {
    this.errorList = new Array(this.issue.fillContext.length)
  },
  watch:{
    'question.questionErrorList'(list){
      this.errorList = new Array(this.issue.fillContext.length)
      this.issue.fillContext.forEach((item,index)=>{
        const key = `${this.question.id}.${item.id}`
        const i = list.find(i=>i.key === key)
        if(!i) return
        this.errorList[index] = i.message
      })
    }
  }
}
</script>
